function addInchUnit(val) {
  if (!val) return '';
  val = val.toString().trim();
  if (!val.endsWith('"') && !val.endsWith('in') && !val.endsWith('inch') && !val.endsWith('inches')) {
    return val + '"';
  }
  return val;
}

function initProductPriceUpdate() {
  const sizeButtons = document.querySelectorAll(".size-btn");
  const priceElements = document.querySelectorAll("#dynamic-price");
  const minLengthvalueElement = document.getElementById("min-length-value");
  const maxLengthvalueElement = document.getElementById("max-length-value");
  const widthValueElement = document.getElementById("width-value");

  const container = document.getElementById("CustomProductMeasurements");
  const widthPill = document.getElementById("CustomProdWidthPill");
  const lengthPill = document.getElementById("CustomProdLengthPill");
  const widthValEl = document.getElementById("CustomWidthVal");
  const lengthValEl = document.getElementById("CustomLengthVal");

  function updateMeasurements(minVal, maxVal, widthVal) {
    if (!container) return;
    let hasData = false;

    const cleanMin = (minVal !== null && minVal !== undefined && minVal !== '—') ? minVal.toString().trim() : '';
    const cleanMax = (maxVal !== null && maxVal !== undefined && maxVal !== '—') ? maxVal.toString().trim() : '';
    const cleanWidth = (widthVal !== null && widthVal !== undefined && widthVal !== '—') ? widthVal.toString().trim() : '';

    if (cleanWidth) {
      if (widthValEl) widthValEl.textContent = addInchUnit(cleanWidth);
      if (widthPill) widthPill.style.display = "inline-flex";
      hasData = true;
    } else {
      if (widthPill) widthPill.style.display = "none";
    }

    if (cleanMin || cleanMax) {
      let lengthStr = '';
      if (cleanMin && cleanMax) {
        lengthStr = `${addInchUnit(cleanMin)}-${addInchUnit(cleanMax)}`;
      } else if (cleanMin) {
        lengthStr = addInchUnit(cleanMin);
      } else if (cleanMax) {
        lengthStr = addInchUnit(cleanMax);
      }
      if (lengthValEl) lengthValEl.textContent = lengthStr;
      if (lengthPill) lengthPill.style.display = "inline-flex";
      hasData = true;
    } else {
      if (lengthPill) lengthPill.style.display = "none";
    }

    container.style.display = hasData ? "block" : "none";
  }

  function selectedSize(button) {
    if (!button) return;
    sizeButtons.forEach((btn) => btn.classList.remove("selected"));
    sizeButtons.forEach((btn) => btn.classList.remove("leash-selected"));

    button.classList.add("selected");

    const variantDataStr = button.getAttribute("data-variant");
    if (!variantDataStr) return;
    
    let variantData;
    try {
      variantData = JSON.parse(variantDataStr);
    } catch (e) {
      console.error("Failed to parse variant data:", e);
      return;
    }

    const minVal = (variantData.minlength !== null && variantData.minlength !== undefined) ? variantData.minlength : '—';
    const maxVal = (variantData.maxlength !== null && variantData.maxlength !== undefined) ? variantData.maxlength : '—';
    const widthVal = (variantData.width !== null && variantData.width !== undefined) ? variantData.width : '—';

    updateMeasurements(minVal, maxVal, widthVal);

    if (button.textContent.trim().toLowerCase() === "leash only") {
      // Clear the content of the elements
      priceElements.forEach((el) => { el.textContent = ""; });
      button.classList.add("leash-selected");
      
      const sizingPriceLabel = document.getElementById("sizing-price-label");
      if (sizingPriceLabel) sizingPriceLabel.style.display = "none";
      
      const buckleTabContainer = document.getElementById("buckle-tab-container");
      if (buckleTabContainer) buckleTabContainer.style.display = "none";
      
      const hardwareTitles = document.getElementsByClassName("hardware-title");
      Array.from(hardwareTitles).forEach((element) => {
        element.style.display = "none";
      });
      
      const dynamicDetails = document.getElementById("dynamic-details");
      if (dynamicDetails) dynamicDetails.style.display = "flex";
      
      if (minLengthvalueElement) minLengthvalueElement.textContent = minVal;
      if (maxLengthvalueElement) maxLengthvalueElement.textContent = maxVal;
      if (widthValueElement) widthValueElement.textContent = widthVal;
      
      // Hide all elements with the class "buckle-section"
      const buckleSections = document.getElementsByClassName("buckle-section");
      Array.from(buckleSections).forEach((element) => {
        element.style.display = "none";
      });
    } else {
      // Update the content with variant data
      priceElements.forEach((el) => { el.textContent = variantData.price || ''; });
      if (minLengthvalueElement) minLengthvalueElement.textContent = minVal;
      if (maxLengthvalueElement) maxLengthvalueElement.textContent = maxVal;
      if (widthValueElement) widthValueElement.textContent = widthVal;
      
      const sizingPriceLabel = document.getElementById("sizing-price-label");
      if (sizingPriceLabel) sizingPriceLabel.style.display = "none";
      
      const buckleTabContainer = document.getElementById("buckle-tab-container");
      if (buckleTabContainer) buckleTabContainer.style.display = "flex";
      
      const hardwareTitles = document.getElementsByClassName("hardware-title");
      Array.from(hardwareTitles).forEach((element) => {
        element.style.display = "block";
      });
      
      const dynamicDetails = document.getElementById("dynamic-details");
      if (dynamicDetails) dynamicDetails.style.display = "flex";
     
      // Show all elements with the class "buckle-section"
      const buckleSections = document.getElementsByClassName("buckle-section");
      Array.from(buckleSections).forEach((element) => {
        element.style.display = "flex";
      });
    }
  }

  let defaultSelected = document.querySelector(".size-btn.selected");
  if (!defaultSelected) {
    defaultSelected = document.querySelector(".size-btn");
  }
  if (defaultSelected) {
    selectedSize(defaultSelected);
  }

  sizeButtons.forEach((button) => {
    button.addEventListener("click", () => {
      selectedSize(button);
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductPriceUpdate);
} else {
  initProductPriceUpdate();
}
